<template>
  <div class="fullprog">
    <div class="profile_page">
      <div class="profile_header">
        <div class="profile_title">Bien 2</div>
        <div class="profile_title1">venue</div>
        <div class="profile_circle"></div>
        <div class="profile_circle1"></div>
        <div class="profile_circle2"></div>
      </div>
      <div class="profile_form">
        <div class="nom_prenom">
          <input
            type="text"
            v-model="nom"
            class="profile_input"
            placeholder="Nom"
            style="width: 49%"
          />
          <input
            type="text"
            v-model="prenom"
            class="profile_input"
            placeholder="Prenom"
            style="width: 49%"
          />
        </div>
        <!--<input type="text" v-model="tel" class="profile_input" placeholder="tel">
                <input type="text" v-model="adresse" class="profile_input" placeholder="Adresse">-->
        <input
          type="text"
          v-model="email"
          class="profile_input"
          placeholder="email"
        />
        <input
          type="password"
          v-model="password"
          class="profile_input"
          placeholder="Mot de passe"
        />
        <input
          type="password"
          v-model="passwordconfirm"
          class="profile_input"
          placeholder="Confirmation du mot de passe"
        />
        <p class="profile_error_message" style="color: red;padding :5px 0;" v-if="password !== passwordconfirm">
      Mots de passes non identiques.
    </p>
        <button class="profile_button" @click="onSubmit()">
          Sign Up <span class="profile_button_circle"></span>
        </button>
      </div>
    </div>
  </div>

</template>
<script>
import axios from "axios";
import { mapActions, mapGetters, mapMutations } from "vuex";

export default {
  name: "Signup",
  data() {
    return {
      nom: "",
      prenom: "",
      tel: "",
      adresse: "",
      email: "",
      password: "",
      passwordconfirm: "",
    };
  },
  methods: {
    ...mapActions(["register", "loginProg", "getClientProg"]),
    async onSubmit() {
      const form = {
        nom: this.nom,
        prenom: this.prenom,
        email: this.email,
        tel: this.tel,
        adresse: this.adresse,
        password: this.password,
        passwordconfirm: this.passwordconfirm,
      };
      const formlogin = {
        email: this.email,
        password: this.password,
      };
      if (this.password !== this.passwordconfirm){
        return;
      }
      this.register(form)
        .then(()=>{ 
          this.loginProg(formlogin)})
        // .then((res) => {
        //   if (res.ok) {
        //     this.getClientProg();
        //     console.log(res.client);
        //   }
        // })
        .then(()=>{
          this.$modal.hide("login")
          setTimeout(() => {
            
            this.$modal.show("profile")
          }, 600);
        });

      // this.router.push('/login')
    },
  },
};
</script>

<style scoped>
.fullprog {
  width: 100%;
  box-sizing: border-box;
  background-color: #264740;
  /* background-color: #f6f3f1; */
}

.profile_page {
  width: 100%;
  height: 90vh;
  flex: 1;
  display: flex;
  flex-direction: column;
}

.profile_header {
  color: #fff;
  flex-direction: column;
  flex: 1;
  padding-top:10%;
  justify-content: center;
  align-items: flex-start;
  padding-left: 24px;
  position: relative;
  margin: 0;
  min-height: fit-content;
}

.profile_title {
  font-size: 62px;
  font-weight: bold;
}

.profile_title1 {
  font-size: 62px;
  font-weight: bold;
  transform: rotate(5deg);
  position: relative;
  bottom: 20px;
}

.profile_circle {
  display: block;
  position: absolute;
  width: 25px;
  height: 25px;
  background: #f05d2e;
  border-radius: 50%;
  top: 26%;
  left: 13px;
}

.profile_circle1 {
  display: block;
  position: absolute;
  width: 25px;
  height: 25px;
  background: #f05d2e;
  border-radius: 50%;
  top: 41%;
  left: 120px;
}

.profile_circle2 {
  display: block;
  position: absolute;
  width: 25px;
  height: 25px;
  background: #f05d2e;
  border-radius: 50%;
  top: 62%;
  left: 19%;
}

.profile_form {
  flex: 2;
  display: flex;
  flex-direction: column;
  padding: 0px 24px;
  padding-bottom: 120px;
}

.profile_input {
  padding: 24px;
  background-color: #fff;
  border-radius: 40px;
  margin-bottom: 20px;
  font-size: 18px !important;
  text-align: center;
  color: #2e4640;
}
.nom_prenom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
}
.profile_button {
  padding: 14px;
  background-color: #fff;
  border-radius: 40px;
  margin-bottom: 12px;
  font-size: 18px !important;
  text-align: center;
  color: #2e4640;
  text-transform: capitalize;
}

.profile_button_circle {
  width: 8px;
  height: 8px;
  background: #f05d2e;
  border-radius: 50%;
  display: inline-block;
  position: relative;
  top: 6px;
}

.profile_forgort {
  width: 100%;
  text-align: right;
  padding-right: 6px;
}

.profile_forgort a {
  color: #fff;
  text-transform: none;
}

.profile_sepatator {
  width: 100%;
  height: fit-content;
  display: flex;
  justify-content: center;
  align-items: center;
}

.profile_sepatator div {
  height: 6px;
  width: 20%;
  background: #fff;
  border-radius: 50px;
}

.proile_social {
  display: flex;
  flex: 2;
  justify-content: center;
  align-items: flex-start;
  gap: 24px;
  padding-top: 24px;
}
</style>